import { Phone } from "lucide-react";
import { useLang } from "../../i18n";
import { useContent } from "../../lib/useContent";

export default function TopBar() {
  const { t } = useLang();
  const c = useContent();
  return (
    <div data-testid="top-info-bar" className="bg-ngo-forest text-ngo-mint text-xs sm:text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between gap-3 py-1.5">
        <p className="truncate">
          <span className="text-ngo-gold font-semibold">{t("top.reg")}:</span> {c.reg_no}
          <span className="hidden sm:inline mx-3 opacity-40">|</span>
          <span className="hidden sm:inline">
            <span className="text-ngo-gold font-semibold">{t("top.est")}:</span> {c.established}
          </span>
        </p>
        <a
          data-testid="topbar-phone-link"
          href={`tel:${c.phone.replace(/\s/g, "")}`}
          className="flex items-center gap-1.5 hover:text-ngo-gold transition-colors duration-200 shrink-0"
        >
          <Phone size={13} />
          <span className="hidden xs:inline sm:inline">{t("top.contact")}:</span> {c.phone}
        </a>
      </div>
    </div>
  );
}
